import axios from "axios";

const BASE_URL = "https://api.linq.legal/";

export let API = null;

export const initializeAPI = () => {
  if (!API) {
    API = axios.create({
      baseURL: BASE_URL,
      headers: { "Content-Type": "application/json" },
    });
  }

  // Add interceptor to inject the Authorization token dynamically
  API.interceptors.request.use(
    (config) => {
      const accessToken = localStorage.getItem("accessToken");
      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  return API;
};
